module.exports = __webpack_public_path__ + "img/mini-019.9f4b2f53.jpg";